// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2QLY1","row":"styles_row__2Y2eP"};